var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.461426,
    width: 43.1958,
    height: 43.0771,
    rx: 21.5386,
    fill: "#317397"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5039 33.077L10.0442 33.0365L10 33.5385H10.5039V33.077ZM21.5809 22.9312L21.6016 23.3923L21.6071 23.392L21.5809 22.9312ZM32.6578 33.077V33.5385H33.1958L33.114 33.0068L32.6578 33.077ZM27.0838 16.9229C27.0838 20.0172 24.7767 22.4613 22.0069 22.4613V23.3844C25.3547 23.3844 28.0069 20.456 28.0069 16.9229H27.0838ZM22.0069 22.4613C19.2371 22.4613 16.93 20.0172 16.93 16.9229H16.0069C16.0069 20.456 18.6591 23.3844 22.0069 23.3844V22.4613ZM16.93 16.9229C16.93 13.8287 19.2371 11.3845 22.0069 11.3845V10.4614C18.6591 10.4614 16.0069 13.3898 16.0069 16.9229H16.93ZM22.0069 11.3845C24.7767 11.3845 27.0838 13.8287 27.0838 16.9229H28.0069C28.0069 13.3898 25.3547 10.4614 22.0069 10.4614V11.3845ZM10.9637 33.1174C11.0988 31.5823 11.794 29.2297 13.4383 27.2245C15.0702 25.2345 17.6482 23.5707 21.6016 23.3923L21.5601 22.4702C17.3336 22.6608 14.5152 24.4555 12.7246 26.6392C10.9464 28.8076 10.1931 31.3434 10.0442 33.0365L10.9637 33.1174ZM21.6071 23.392C22.8532 23.321 25.2041 23.7534 27.3955 25.2174C29.5678 26.6686 31.5836 29.1334 32.2016 33.1472L33.114 33.0068C32.4539 28.7194 30.2804 26.0346 27.9083 24.4498C25.5552 22.8777 23.0067 22.3877 21.5546 22.4705L21.6071 23.392ZM32.6578 32.6155H10.5039V33.5385H32.6578V32.6155Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientProfile);
export default __webpack_public_path__ + "static/media/Patient_Profile.90e9444988d1b705a8b3d8e814f51f82.svg";
export { ForwardRef as ReactComponent };